<template>
    <div>
        <input type="file" @change="uploadVideo" class="d-none" accept="video/mp4, video/webm, video/ogg">
        <div class="align-items-start">
            <template v-if="videoPath">
                <div class="row">
                    <div class="col-sm-10 pr-0">
                        <b-button class="ds-btn ds-btn--default" block href="#" v-b-toggle="`accordion-${videoPath}`">
                            Video paraugs
                        </b-button>
                    </div>
                    <div class="col-sm-2 pl-0">
                        <button class="ds-btn ds-btn--danger" type="button" @click="deleteVideo" :disabled="isProcessing">
                            <font-awesome-icon icon="trash"/>
                        </button>
                    </div>
                </div>
            </template>
            <template v-else>
                <button class="ds-btn btn-block" type="button" @click="pickVideo" :disabled="isProcessing">
                    Izvēlēties video (mp4,webm,ogg)
                </button>
            </template>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'video-upload',
        props: {
            video: {
                type: String,
            },
            documentId: {
                type: String,
            },
        },
        data() {
            return {
                videoPath: this.video,
                isProcessing: false,
            }
        },
        methods: {
            pickVideo() {
                this.$el.querySelector('input').click();
            },
            async uploadVideo(e) {
                const [video] = e.target.files;

                if (!video) {
                    return;
                }

                this.isProcessing = true;

                const formData = new FormData;
                formData.append('video', video);

                const {data: {videoPath, success}} = await axios.post('/api/uploads/video', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });

                if (!success) {
                    return alert('Kaut kas nogāja greizi.');
                }

                this.videoPath = '/' + videoPath;
                this.$emit('uploaded', this.videoPath);

                this.isProcessing = false;
                e.target.value = '';
            },
            async deleteVideo() {
                this.isProcessing = true;

                const {data: {success}} = await axios.post('/api/uploads/unlink-file', {videoPath: this.videoPath, documentId: this.documentId});

                if (!success) {
                    return alert('Neizdevās izdzēst video.');
                }

                this.isProcessing = false;
                this.videoPath = '';

                this.$emit('deleted', this.videoPath);
            },
        }
    }
</script>